import * as React from 'react';
import { FC } from 'react';
import {
    Create,
    TextInput,
    TextField,
    Toolbar,
    FormWithRedirect,
    required,
    minLength,
    maxLength,
} from 'react-admin';
import { Box, Card, CardContent } from '@material-ui/core';
import { Team, FieldProps } from '../types';

const TeamCreate = (props: any) => {
    return (
        <Create title={<TeamTitle />} component="div" {...props}>
            <TeamForm />
        </Create>
    );
};

const TeamTitle: FC<FieldProps<Team>> = ({ record }) =>
    record ? <TextField source="title" record={record} size="32" /> : null;

const TeamForm = (props: any) => {
    const validatename = [required(), minLength(1), maxLength(30)];

    return (
        <FormWithRedirect
            {...props}
            redirect="list"
            render={(formProps: any) => (
                <Card>
                    <form>
                        <CardContent>
                            <Box display={{ md: 'block', lg: 'flex' }}>
                                <Box flex={2} mr={{ md: 0, lg: '1em' }}>
                                    <TextInput
                                        type="name"
                                        source="name"
                                        label="resources.teams.fields.name"
                                        validate={validatename}
                                        fullWidth
                                    />
                                </Box>
                            </Box>
                        </CardContent>
                        <Toolbar
                            record={formProps.record}
                            basePath={formProps.basePath}
                            invalid={formProps.invalid}
                            handleSubmit={formProps.handleSubmit}
                            saving={formProps.saving}
                            resource="teams"
                        />
                    </form>
                </Card>
            )}
        />
    );
};

export default TeamCreate;
